<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <addHeader
          :title="$t('Create A Product Detail')"
          :description="$t('From Here You Can Create New Product Details')"
          v-if="$route.name == 'detailsCreate'"
        />
        <addHeader
          :title="$t('Edit Product Detail')"
          :description="$t('From Here You Can Modify The Details Of The Products')"
          v-if="$route.name == 'detailsEdit'"
        />
        <div class="mb-4 row">
          <dvider
            :title="$t('Products Detail Information')"
            :description="$t('Basic Information For Product Detail')"
            noLine="true"
          />
          <formInput
            :title="$t('Product Detail Name')"
            v-model="item.name"
            :hasErorr="errors.name"
            :error="$t('This field Is required')"
            :col="'col-12'"
            maxlength="255"
          />
          <!-- Divider -->
          <hr class="mt-5 mb-5 col-12" />
          <!-- Buttons -->
          <a
            @click="saveItem"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'detailsCreate' && !$parent.stopEdit"
          >
            {{ $t('Create Product Details') }}
          </a>
          <a
            @click="saveItem"
            class="btn btn-block btn-primary"
            v-if="$route.name == 'detailsEdit' && !$parent.stopEdit"
          >
            {{ $t('Edit Product Detail') }}
          </a>
          <loading v-if="$parent.stopEdit" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

import formInput from '@/elements/add/form/formInput.vue'
import dvider from '@/elements/add/dvider.vue'
import addHeader from '@/elements/add/header.vue'
import loading from '@/elements/add/loading.vue'
export default {
  data() {
    return {
      path: '/details',
      item: {},
      errors: {
        name: false
      }
    }
  },
  methods: {
    getItem() {
      axios.get(this.$linkGenerator(this.path + '/' + this.$route.params.id)).then((response) => {
        this.item = response.data
        this.$parent.stopEdit = false
      })
    },
    saveItem() {
      var error = 0
      if (typeof this.item.name === 'undefined' || this.item.name == '') {
        error = 1
        this.errors.name = true
      }
      if (error == 0) {
        if (this.$route.name == 'detailsCreate') {
          this.$parent.aletText = this.$t('section Successfully Added')
          this.$parent.alertType = 'success'
          this.$addToLocalDatabase(this.item, this.path.substring(1))
          this.$router.go(-1)
        } else if (this.$route.name == 'detailsEdit') {
          this.item._method = 'PUT'
          this.$parent.stopEdit = true
          axios
            .post(this.$linkGenerator(this.path + '/' + this.item.id), this.item)
            .then((response) => {
              this.$parent.aletText = this.$t('section Has Been Modified Successfully')
              this.$parent.alertType = 'success'
              this.$router.go(-1)
              this.$parent.stopEdit = false
              return response
            })
        }
      } else {
        this.$parent.aletText = this.$t('please MakeSure Of TheInput')
        this.$parent.alertType = 'danger'
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    }
  },
  mounted() {
    if (this.$route.name == 'detailsEdit') {
      this.$parent.stopEdit = true
      this.getItem()
    }
  },
  components: {
    formInput,
    dvider,
    addHeader,
    loading
  }
}
</script>
<style></style>
